import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function serviceRequestDetailReducer(state = initialstate.serviceRequestDetail, action) {
	switch (action.type) {
		case types.RESET_SERVICE_REQUEST_DETAIL:
			return {};
		default:
			return state;
	}
}
